import TopNav from './TopNav';
import { TopNavProps, TopNavValueProps } from './types';

export type { TopNavProps, TopNavValueProps };
export default TopNav;
